module.exports = __webpack_public_path__ + "img/Haha.1fde4701.svg";